module.exports = __webpack_public_path__ + "static/img/jinggao.3f17451.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jinggao.png
// module id = 315
// module chunks = 1